import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import * as ClaimTrackerModels from '@claim-tracker/common/models';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';

import { NavService } from '../services/nav/nav.service';

/**
 * Interceptor which can detect errors caused by the gateway entering maintenance mode.
 *
 * @param req {HttpRequest} the request being processed
 * @param next {HttpHandlerFn} the next handler in the chain, or the actual http call
 */
export function MaintenanceInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
	const navService = inject(NavService);
	return next(req).pipe(
		catchError((err: unknown) => {
			if (
				err instanceof HttpErrorResponse &&
				err.error?.error === ClaimTrackerModels.com.aoins.claims.common.ClaimTrackerErrors.IN_MAINTENANCE
			) {
				navService.toMaintenance();
				return EMPTY;
			}
			return throwError(() => err);
		})
	);
}
